module.exports = __webpack_public_path__ + "img/bilge-pump-on.a19883fc.svg";